import { ProgramCategory } from "@types";
import { FC, Fragment, useEffect, useState } from "react";
import ProgramItem from "./programItem";
import ProgramItemContent from "./programItemContent";
import SubscriptionBannerAdvertisement from "@shared/components/subscription-advertisement";

interface Props {
  category: ProgramCategory;
  offsetTop: number;
  isFirst: boolean;
  clickedCategory: number | null;
  resetClickedCategory: () => void;
  scrollMargin: number;
  showingBannerProductId: number;
}

const getDefaultAccordionValue = (
  category: ProgramCategory,
  isFirst: boolean
) => {
  return category
    ? (category.subCategories || []).map((_s, i) => isFirst && i < 3)
    : [];
};

const CategoryItem: FC<Props> = ({
  category,
  offsetTop,
  isFirst,
  clickedCategory,
  resetClickedCategory,
  scrollMargin,
  showingBannerProductId,
}) => {
  const [accordionsStatus, setAccordionsStatus] = useState<boolean[]>(
    getDefaultAccordionValue(category, isFirst)
  );

  useEffect(() => {
    if (clickedCategory !== null)
      setAccordionsStatus((prev) =>
        prev.map((p, i) => (category.id === clickedCategory && i === 0) || p)
      );
  }, [clickedCategory]);

  const accordionChangeHandler = (index: number) => {
    setAccordionsStatus((prev) => {
      const copy = [...prev];
      copy[index] = !copy[index];
      return copy;
    });
    resetClickedCategory();
  };

  return (
    <div
      className="relative scroll lg:scroll-m-28"
      id={`${category.id}-programs`}
      style={{
        scrollMarginTop: `${scrollMargin}px`,
      }}
    >
      <div
        className="bg-fds-primary sticky z-20 my-0.5 py-2 px-4 md:px-8 lg:px-0"
        style={{
          top: `${offsetTop}px`,
        }}
      >
        <div className="w-full p-2 rounded-8 bg-fds-brand-light">
          <h2 className="text-center title-lg text-fds-brand-select">
            {category.name}
          </h2>
        </div>
      </div>
      <div className="flex flex-col gap-2.5 px-4 md:px-8 lg:px-0">
        {(category.subCategories || []).map((subCategory, i) => {
          const showSubscriptionBanner =
            subCategory.products?.findIndex?.(
              (p) => p.id === showingBannerProductId
            ) !== -1;

          return (
            <Fragment key={subCategory.id}>
              <ProgramItem
                content={subCategory}
                onClickAccordion={() => accordionChangeHandler(i)}
                isOpen={Boolean(accordionsStatus[i] ?? true)}
              >
                {subCategory.products?.length
                  ? subCategory.products.map((product) => (
                      <ProgramItemContent key={product.id} content={product} />
                    ))
                  : ""}
              </ProgramItem>
              {showSubscriptionBanner && (
                <SubscriptionBannerAdvertisement
                  type="program"
                  className="my-1.5 md:my-6"
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryItem;
